import React from "react";
import { makeStyles } from "@material-ui/core/styles";

export const accountCss = makeStyles((theme) => ({
    divV1: {
        display: 'flex'
    },
    divV2: {
        display: 'flex', justifyContent: 'space-between', width: '100%'
    },
    divV3: {
        backgroundColor: '#f1f1f3', padding: 11, borderRadius: '8px'
    },
    divV4: {
        display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '16px', borderRadius: '8px'
    },
    divV5: {
        fontSize: 24, fontWeight: 500, width: '85%', textAlign: 'center'
    },
    divV6: {
        display: 'flex', alignItems: 'center', marginTop: 16, fontWeight: 300
    },
    divV7: {
        backgroundColor: '#f1f1f3', padding: 24, borderRadius: '8px', marginTop: 24, minWidth: '292px'
    },
    divV8: {
        color: '#6b778c', fontSize: 16, fontWeight: 300
    },
    divV9: {
        fontSize: 18, fontWeight: 300, marginTop: 2
    },
    divV10: {
        backgroundColor: '#f1f1f3', marginTop: 24, wordBreak: "break-word", paddingLeft: 24, paddingRight: 28, paddingTop: 24, paddingBottom: 24, borderRadius: '8px', width: '292px'
    },
    divV11: {
        marginTop: 24, fontSize: 16, color: '#6b778c'
    },
    divV12: {
        fontSize: 18, marginTop: 4
    },
    divV13: {
        fontSize: 18, color: '#0033cc', marginTop: 4
    },
    divV14: {
        fontSize: 16, color: '#6b778c'
    },
    divV15: {
        display: 'flex', marginTop: 16, justifyContent: 'space-between'
    },
    fBV1: {
        flexBasis: '50%'
    },
    fBV2: {
        flexBasis: '50%', paddingLeft: 4
    },
    mtV1: {
        marginTop: 16
    },
    cardV1: {
        borderRadius: '8px', minHeight: 440, marginLeft: 16
    },
    cardContentV1: {
        paddingLeft: 26, paddingRight: 26, paddingTop: 24, paddingBottom: 40, fontWeight: 300
    },
    divFlex: {
        display: 'flex', flexDirection: 'column', alignItems: 'center'
    },
    divFlexV1: {
        display: 'flex', alignItems: 'center', justifyContent: 'center'
    },
    nameV1: {
        fontSize: '16px', opacity: '0.6'
    },
    recordIcon: {
        borderRadius: '50%', backgroundColor: 'lightgrey', color: 'lightgrey', fontSize: 8, marginLeft: 8, marginRight: 8
    },
    divImg: {
        backgroundColor: '#f1f1f3', borderRadius: 8
    },
    imgV1: {
        width: 120, height: 120, borderRadius: 8
    },
    divAddress: {
        fontSize: '24px', fontWeight: 300
    },
    divV16: {
        position: 'relative'
    }
}));

export const userManagementCss = makeStyles((theme) => ({

    gridV1: {
        width: '100%'
    },
    paperV1: {
        width: '97%',
        height: '98%',
        marginLeft: 30,
        marginTop: 15,
        borderRadius: 8
    },
    userManagementEmpty: {
        fontSize: '22em'
    },
    divV1: {
        fontSize: 28,
        fontWeight: 'bold'
    },
    divV2: {
        marginTop: 16,
        fontSize: 22,
        opacity: 0.6
    },
    addButton: {
        color: 'white',
        textTransform: 'capitalize',
        fontWeight: 500,
        fontSize: 14,
        backgroundColor: '#0033cc',
        borderRadius: 4,
        paddingTop: 7,
        paddingBottom: 7,
        paddingLeft: 16,
        paddingRight: 16,
        '&:hover': {
            backgroundColor: '#0033cc'
        }
    },
    mtV1: {
        marginTop: 24
    },
    divAlign: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: 'inherit'
    },
    divV3: {
        marginTop: 48,
        textAlign: 'center'
    },
    divV4: {
        fontSize: 20,
        fontWeight: 'bold'
    },
    mtV2: {
        marginTop: 16
    },
    divTable: {
        paddingLeft: 22,
        paddingRight: 22,
        paddingTop: 16,
        paddingBottom: 16
    },
    buttonInactive: {
        backgroundColor: '#fceeeb',
        border: '1px solid #de1c22',
        color: '#de1c22',
        borderRadius: 4,
        minWidth:127,
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 2,
        paddingBottom: 2,
        fontSize: 14,
        textTransform: 'capitalize',
        '&:hover': {
            backgroundColor: '#fceeeb'
        }
    },
    edit: {
        backgroundColor: '#0033cc',
        color: '#fff',
        borderRadius: 4,
        padding:'6px 24px',
        fontSize: 14,
        boxShadow:'none',
        textTransform: 'capitalize',
        '&:hover': {
            backgroundColor: '#0033cc'
        }
    },
    buttonActive: {
        backgroundColor: '#d2dcfb',
        border: '1px solid #0033cc',
        color: '#0033cc',
        borderRadius: 4,
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 2,
        paddingBottom: 2,
        fontSize: 14,
        minWidth:127,
        textTransform: 'capitalize',
        '&:hover': {
            backgroundColor: '#d2dcfb'
        }
    },
    buttonMakeActive: {
        backgroundColor: '#d8f1e9',
        border: '1px solid #00875a',
        color: '#00875a',
        minWidth:127,
        borderRadius: 4,
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 2,
        paddingBottom: 2,
        fontSize: 14,
        textTransform: 'capitalize',
        '&:hover': {
            backgroundColor: '#d8f1e9'
        }
    },
    buttonCancelActive: {
        backgroundColor: '#fdefe7',
        border: '1px solid #e86825',
        color: '#e86825',
        borderRadius: 4,
        minWidth:127,
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 2,
        paddingBottom: 2,
        textTransform: 'capitalize',
        fontSize: 14,
        '&:hover': {
            backgroundColor: '#fdefe7'
        }
    }

}));